import React, { Component } from 'react';
import {connect} from 'react-redux';
import AddCoupon from '../../components/coupon'
import CouponListView from '../../components/coupon/couponList';
import {AddCouponData, fetchAllCoupons, createCouponView} from '../../actions/coupon'


class Coupon extends Component {
  constructor(props){
    super(props)
    this.state={

    };
    this.showPaymentView = this.showPaymentView.bind(this);
    this.AddCoupon = this.AddCoupon.bind(this);
    this.createCouponView = this.createCouponView.bind(this);
    this.couponListViewPage = this.couponListViewPage.bind(this);
  }

  
  componentWillMount() {
    let token=sessionStorage.getItem("adminToken");
   this.props.dispatch(fetchAllCoupons(token));
  }

  couponListViewPage(){
    let token=sessionStorage.getItem("adminToken");
   this.props.dispatch(fetchAllCoupons(token));
  }

  showPaymentView(){
    this.props.history.push('/payment');
  }

  AddCoupon(data){
    this.props.dispatch(AddCouponData(data));
  }

  createCouponView(){
    this.props.dispatch(createCouponView());
  }

  render(){
    let showCouponView ="";

    if(this.props.showCouponListView){
      showCouponView = <CouponListView
                        couponListSuccess = {this.props.couponListSuccess}
                        couponListData = {this.props.couponListData}
                        createCouponView = {this.createCouponView}
                        />
    }else if(this.props.showCreateView){
      showCouponView = <AddCoupon
                        AddCoupon = {this.AddCoupon}
                        success = {this.props.success}
                        couponSaveResponse = {this.props.couponSaveResponse}
                        couponListViewPage = {this.couponListViewPage}
                      />
    }
  
    return (
        <div> 
             {showCouponView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    success : state.coupon.success,
    couponSaveResponse : state.coupon.couponSaveResponse,
    showCouponListView :  state.coupon.showCouponListView,
    couponListSuccess : state.coupon.couponListSuccess,
    couponListData :  state.coupon.couponListData,
    showCreateView : state.coupon.showCreateView
  }
}

export default connect(mapStateToProps)(Coupon);



// WEBPACK FOOTER //
// ./src/pages/Coupon/index.js